import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet, Router } from '@angular/router';
import { ButtonComponent } from '@akostm/orbit-ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { WireApiService } from '@frontend/shared';

@Component({
  selector: 'lib-settings',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RouterOutlet,
    ButtonComponent,
    TranslatePipe,
    FontAwesomeModule,
  ],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  navItems = [
    { label: 'SETTINGS.GENERAL.TITLE', route: 'general' },
    { label: 'SETTINGS.USERS.TITLE', route: 'users' },
    { label: 'SETTINGS.WEBHOOKS.TITLE', route: 'webhooks' },
    { label: 'SETTINGS.MESSAGE_TEMPLATES.TITLE', route: 'message-templates' },
    { label: 'SETTINGS.WORKFLOWS.TITLE', route: 'workflows' },
    { label: 'SETTINGS.CONVERSATION_TYPES.TITLE', route: 'conversation-types' },
    { label: 'Theme', route: 'theme-colors' },
    { label: 'SETTINGS.API_KEYS.TITLE', route: 'api-keys' },
  ];

  // Icons
  readonly faBars = faBars;
  readonly faTimes = faTimes;

  // Mobile menu state
  mobileMenuOpen = false;

  readonly #router = inject(Router);
  readonly #translateService = inject(TranslateService);
  readonly #wireApiService = inject(WireApiService);

  constructor() {
    // Ensure translations are loaded
    this.#translateService.setDefaultLang('en');
    this.refreshCredentials();
  }

  closeSettings() {
    this.#router.navigate(['/']);
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }

  refreshCredentials() {
    this.#wireApiService.signInWithStoredCredentials();
  }
}
